
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/renfield-rules",
      function () {
        return require("private-next-pages/renfield-rules.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/renfield-rules"])
      });
    }
  